import { Button } from '@code/innovance-react-ui-kit';
import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

// TODO : (emre.yildirim) move these styles to a common folder
export const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  flex-direction: column;

  padding-left: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    padding: 0;
  }
`;

export const Title = styled.h1`
  margin: 10px 0;

  color: ${({ theme }) => theme.palette.black};

  font-size: 16px;
`;

export const Subtitle = styled.h2`
  margin: 5px 0;

  color: ${({ theme }) => theme.palette.black};

  font-size: 14px;
`;

export const CustomLabel = styled.p`
  margin-top: 5px;

  color: ${({ theme }) => theme.palette.black};

  font-size: 14px;
`;

export const InformationSubTitle = styled(Subtitle)<{ topPadding?: string }>`
  padding-top: ${({ topPadding }) => topPadding};

  color: red;
`;

export const Description = styled.h3`
  margin: 5px 0;

  color: ${({ theme }) => theme.palette.black};

  font-size: 14px;
  font-weight: normal;
`;

export const Separator = styled.div`
  padding: 10px 0;
`;

export const Form = styled.form`
  position: relative;

  width: fit-content;
`;

export const FormRow = styled.div`
  display: flex;
  width: 685px;
  margin: 10px 0;
  justify-content: space-between;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 575px;
  }
`;
export const ButtonFormRow = styled.div`
  display: flex;
  width: auto;
  margin: 10px 0;
  justify-content: start;
  flex-wrap: wrap;
  & > div {
    box-sizing: border-box;
    margin: 1rem 0.5em;

    max-width: calc(33% - 1em);
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    & > div {
      max-width: 100%;
    }
  }
  @media screen and (min-width: ${BREAK_POINTS.MIN.LARGE_2X}) {
    width: 1310px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_2X}) and (min-width: ${BREAK_POINTS.MIN
      .LARGE_1X}) {
    width: 1205px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .TABLET}) {
    width: 950px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 750px;
  }
`;
export const CheckboxRow = styled(FormRow)`
  margin: 16px 0 10px;
`;

export const FormGrid = styled.div`
  display: flex;
  width: 685px;
  justify-content: space-between;

  flex-wrap: wrap;

  & > div {
    margin: 10px 0 0;

    flex: 0 49%;
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 575px;
  }
`;

export const ButtonRow = styled(FormRow)`
  justify-content: flex-end;
`;

export const LongFormRow = styled(FormRow)`
  width: 850px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 600px;
  }
`;

export const ButtonsRow = styled(FormRow)`
  width: 360px;
`;

export const WarningText = styled.div`
  margin-top: 15px;

  color: ${({ theme }) => theme.palette.butterscotch};
`;

export const ResetButton = styled(Button)`
  border: none;
`;

export const ObserveTableWrapper = styled.div`
  width: auto;
  @media screen and (min-width: ${BREAK_POINTS.MIN.LARGE_2X}) {
    width: 1310px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_2X}) and (min-width: ${BREAK_POINTS.MIN
      .LARGE_1X}) {
    width: 1205px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .TABLET}) {
    width: 950px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 750px;
    overflow-x: scroll;
  }
`;
export const TableWrapper = styled.div`
  width: auto;

  @media screen and (min-width: ${BREAK_POINTS.MIN.LARGE_2X}) {
    width: 1050px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_2X}) and (min-width: ${BREAK_POINTS.MIN
      .LARGE_1X}) {
    width: 950px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .TABLET}) {
    width: 850px;
    overflow-x: scroll;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 600px;
    overflow-x: scroll;
  }
`;
export const WarningContainer = styled.div`
  display: flex;
`;

export const WarningIcon = styled.img`
  padding-right: 5px;
`;

export const TableContainer = styled.div`
  width: 100%;
  margin: 10px 0;

  max-width: 900px;
`;

export const FormElement = styled.div`
  width: 335px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 280px;
  }
`;

export const CheckboxElement = styled.div`
  width: 700px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 600px;
  }
`;

export const ButtonElement = styled.div`
  width: 700px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 600px;
  }
`;

export const LineFormElement = styled(FormElement)`
  width: 685px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    width: 575px;
  }
`;

export const CheckboxContainer = styled(FormElement)`
  display: flex;
  align-items: center;

  height: auto;
`;

export const Label = styled.span`
  display: flex;
  margin: 10px 0;

  font-family: GothamMedium, sans-serif;
`;

export const InfoLabel = styled.div`
  display: inline-block;
  width: 170px;
`;

export const InfoRow = styled.div`
  display: flex;
  margin: 10px 0;
`;

export const LineSeparator = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.palette.deepSeaBlue20};
`;

export const InfoColumn = styled.div`
  width: 35%;
  float: left;

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 45%;
    float: left;
  }
`;

export const PlasticCardRow = styled(ButtonFormRow)`
  & > div {
    margin: 5px 10px 5px 0;

    max-width: calc(50% - 1em);
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    & > div {
      max-width: 40%;
    }
  }
  @media screen and (min-width: ${BREAK_POINTS.MIN.LARGE_2X}) {
    width: 1000px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_2X}) and (min-width: ${BREAK_POINTS.MIN
      .LARGE_1X}) {
    width: 900px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .TABLET}) {
    width: 700px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 750px;
  }
`;

export const TextAreaContainer = styled.div`
  width: 100%;
`;
export const ButtonListRow = styled.div`
  display: flex;
  width: 1000px;
  margin: 10px 0;
  @media only screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    display: block;
  }
`;
